import { CTRL_445 } from '../../../../formulaires/validators/445/ctrl445';
import { CTRL_1169 } from '../../../../formulaires/validators/1169/ctrl1169';
import { TypeIndexation } from '../../../../formulaires/common/models/type.indexation';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step8 } from '../../../../shared/models/component-messages/blocCommun/divers/step8';
import { CTRL_1206 } from '../../../../formulaires/validators/1206/ctrl1206';
import { CTRL_1204 } from '../../../../formulaires/validators/1204/ctrl1204';
import { CriteresIndexationHelper } from '../../../../formulaires/common/helpers/CriteresIndexationHelper';

@Component({
  selector: 'app-type-indexation',
  templateUrl: './type-indexation.component.html',
  styleUrls: ['./type-indexation.component.scss']
})
export class TypeIndexationComponent implements OnInit, OnChanges {

  @Input() uid = '';
  public current_uid = 'TypeIndexation';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() indexPage: any;

  @Input() indexation: TypeIndexation;

  public step8 = new Step8();
  public rg1 = CTRL_1169.id + '_1';
  public rg2 = CTRL_445.id + '_1';
  public rg3 = CTRL_1206.id + '_1';
  public rg4 = CTRL_1204.id + '_1';

  constructor() { }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.indexation && !changes.indexation.firstChange && this.parentForm) {
      const nomOrganismeCtrl = this.parentForm.controls._SepSep_TypeIndexation_SepAtt_nomOrganisme;
      if (nomOrganismeCtrl && this.indexation?.nomOrganisme) {
        nomOrganismeCtrl.setValue(this.indexation.nomOrganisme);
      }
      const dateFinDiffusionCtrl = this.parentForm.controls._SepSep_TypeIndexation_SepAtt_dateFinDiffusion;
      if (dateFinDiffusionCtrl && this.indexation?.dateFinDiffusion) {
        dateFinDiffusionCtrl.setValue(this.indexation.dateFinDiffusion);
      }
      this.applyCriteresDefaults();
    }
  }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_1169Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: this.getCtrl_445Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: this.getCtrl_1206Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: this.getCtrl_1206Names_json() }));

    this.applyCriteresDefaults();
  }

  /**
   * Défaut 'Non' des critères sociaux et environnementaux (PRB0052504).
   * La règle elle-même est portée par CriteresIndexationHelper, partagé avec les deux extracteurs.
   *
   * Appliqué au chemin eForms comme au chemin national : le composant app-type-indexation est
   * partagé par stepper.component.html et type-ann.component.html.
   *
   * Depuis ngOnInit, seule l'affectation sur le modèle agit : les FormControl des deux radios sont
   * créés par les app-form-input enfants, dont le ngOnInit s'exécute APRÈS celui de ce composant.
   * L'enfant relit ensuite la valeur du modèle via [value]. Le setValue du helper n'est utile que
   * depuis ngOnChanges, où les contrôles existent déjà.
   */
  private applyCriteresDefaults(): void {
    // indexation est null lorsque fadIndex vaut 1 (cf. stepper.component.ts) : le helper l'ignore.
    CriteresIndexationHelper.applyDefaults(this.indexation, this.parentForm);
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return '_STEP_ID_SepSep_TypeIndexation';
  }

  private getCtrl_1169Names_json(): any {
    const firstChamp = '_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    return { firstChamp };
  }

  private getCtrl_445Names_json(): any {
    const firstChamp = '_SepSep_TypeIndexation_SepAtt_dateFinDiffusion';
    return { firstChamp };
}

  private getCtrl_1206Names_json(): any {
    const motsClef = '_SepSep_TypeIndexation_SepSep_TypeMotsClef_SepAtt_motClef';
    return { motsClef };
  }

}

